// @flow

export const VIEW = { MAIN: 'main', CAMERA: 'camera', UPLOADS: 'uploads' };
